// Mock data for JAPAMIX Restaurant Landing Page - SEO Optimized

// Logo URL
export const logoUrl = "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/4ynln0qh_PHOTO-2026-01-20-14-01-36.jpg";

export const restaurantInfo = {
  name: "Japamix",
  fullName: "Restaurante Japonês Japamix",
  tagline: "Restaurante Japonês em Anápolis | Japamix",
  subtitle: "Sushi, temakis e combinados preparados com ingredientes frescos e qualidade premium.",
  description: "O Japamix é um restaurante japonês em Anápolis especializado em sushi fresco, sashimi premium e combinados artesanais. Com ingredientes selecionados e preparo tradicional japonês, oferecemos uma experiência gastronômica única para você saborear no salão ou receber no conforto da sua casa através do nosso delivery japonês em Anápolis.",
  descriptionExtended: "Há mais de 5 anos levando o melhor da culinária japonesa para Anápolis, o Japamix se tornou referência em qualidade e sabor. Nossos sushimen são especialistas em criar combinações perfeitas de sabores, utilizando peixes frescos e ingredientes importados. Se você procura pedir sushi em Anápolis com qualidade premium, o Japamix é o lugar certo.",
  phone: "(62) 99179-3559",
  whatsapp: "5562995304210", // WhatsApp Restaurante
  whatsappDelivery: "5562991793559", // WhatsApp Delivery
  email: "contato@japamix.com.br",
  address: {
    street: "R. Daise Fanstone, Qd 3 - Lt 57",
    neighborhood: "Cidade Universitária",
    city: "Anápolis",
    state: "GO",
    cep: "75083-450",
    full: "R. Daise Fanstone, Qd 3 - Lt 57 - Cidade Universitária, Anápolis - GO, 75083-450"
  },
  googleMapsUrl: "https://maps.google.com/?q=R.+Daise+Fanstone,+Qd+3+-+Lt+57+-+Cidade+Universitária,+Anápolis+-+GO,+75083-450",
  menuUrl: "https://ncommerce-customer.vercel.app/menu/japa-mix",
  deliveryUrl: "https://delivery.japamiix.com.br/home",
  social: {
    instagram: "https://www.instagram.com/japamiix/"
  },
  seo: {
    title: "Restaurante Japonês em Anápolis | Japamix Sushi",
    description: "Japamix é restaurante japonês em Anápolis com sushi fresco, combinados e delivery rápido. Peça pelo WhatsApp ou iFood.",
    keywords: "restaurante japonês anápolis, sushi anápolis, delivery japonês anápolis, comida japonesa anápolis, temaki anápolis, sashimi anápolis, japamix"
  }
};

export const operatingHours = [
  { day: "Segunda-feira", hours: "18:00 - 23:00", closed: false },
  { day: "Terça-feira", hours: "18:00 - 23:00", closed: false },
  { day: "Quarta-feira", hours: "18:00 - 23:00", closed: false },
  { day: "Quinta-feira", hours: "18:00 - 23:00", closed: false },
  { day: "Sexta-feira", hours: "18:00 - 23:00", closed: false },
  { day: "Sábado", hours: "18:00 - 23:00", closed: false },
  { day: "Domingo", hours: "18:00 - 23:00", closed: false }
];

export const highlights = [
  {
    icon: "Leaf",
    title: "Ingredientes Frescos",
    description: "Selecionamos diariamente os melhores ingredientes para garantir frescor e qualidade em cada prato de sushi em Anápolis."
  },
  {
    icon: "ChefHat",
    title: "Tradição Japonesa",
    description: "Técnicas tradicionais japonesas combinadas com toques contemporâneos para uma experiência autêntica."
  },
  {
    icon: "Clock",
    title: "Atendimento Rápido",
    description: "Agilidade sem perder a qualidade, tanto no salão quanto no delivery japonês em Anápolis."
  },
  {
    icon: "Truck",
    title: "Delivery Expresso",
    description: "Receba comida japonesa delivery em Anápolis no conforto da sua casa."
  }
];

export const menuCategories = [
  {
    id: 1,
    name: "Sushis",
    description: "Peças artesanais com peixe fresco",
    image: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/agqdzzhx_9e21a562-e14a-4de3-9afb-1868d1e37190.JPG",
    altText: "Sushi fresco do Japamix em Anápolis",
    items: ["Sushi de Salmão", "Sushi de Atum", "Sushi Skin"]
  },
  {
    id: 2,
    name: "Temakis",
    description: "Cones crocantes e recheados",
    image: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/zudy3090_27400cac-96e7-49cc-ab11-d0ad181c010d.JPG",
    altText: "Temaki crocante do Japamix Anápolis",
    items: ["Temaki de Salmão", "Temaki Skin", "Temaki Philadelphia"]
  },
  {
    id: 3,
    name: "Combinados",
    description: "Seleções especiais do chef",
    image: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/yxysotlz_PHOTO-2026-01-20-14-00-27.jpg",
    altText: "Combinado japonês delivery Anápolis Japamix",
    items: ["Combinado 15 peças", "Combinado 30 peças", "Combinado Casal"]
  },
  {
    id: 4,
    name: "Pratos Quentes",
    description: "Delícias da culinária oriental",
    image: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/s4cxwgkq_46b400da-5f03-4c65-a694-7540be280e9a.JPG",
    altText: "Yakisoba e pratos quentes Japamix Anápolis",
    items: ["Yakisoba", "Gyoza", "Tempurá"]
  },
  {
    id: 5,
    name: "Sobremesas",
    description: "Doces orientais irresistíveis",
    image: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/kg7xcpv2_PHOTO-2026-01-20-14-00-28%204.jpg",
    altText: "Harumaki de chocolate Japamix Anápolis",
    items: ["Harumaki de Chocolate", "Harumaki de Banana", "Mochi"]
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/yxysotlz_PHOTO-2026-01-20-14-00-27.jpg",
    alt: "Combinado japonês premium Japamix Anápolis"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/smaaa8s2_PHOTO-2026-01-20-14-00-28%202.jpg",
    alt: "Sashimi fresco restaurante japonês Anápolis"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/j9jj8cx2_PHOTO-2026-01-20-14-00-28%203.jpg",
    alt: "Hot roll crispy Japamix Anápolis"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/5bctoimx_PHOTO-2026-01-20-14-00-30%202.jpg",
    alt: "Temaki premium delivery japonês Anápolis"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/4azr74pf_PHOTO-2026-01-20-14-00-30%203.jpg",
    alt: "Sushi especial Japamix Anápolis"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/jpnd6605_PHOTO-2026-01-20-14-00-30.jpg",
    alt: "Prato japonês especial Japamix"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/5a7furw7_PHOTO-2026-01-20-14-00-29%202.jpg",
    alt: "Comida japonesa Anápolis Japamix"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/kg7xcpv2_PHOTO-2026-01-20-14-00-28%204.jpg",
    alt: "Harumaki de chocolate Japamix"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/k6wm1cqx_PHOTO-2026-01-20-14-00-28.jpg",
    alt: "Tempurá de camarão delivery japonês Anápolis"
  }
];

export const videoUrl = "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/lki9uvxd_2f58ee24-f21b-4400-8a7d-83dfd937e203.mov";

// Schema Markup JSON-LD
export const schemaMarkup = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "name": "Japamix",
  "image": "https://customer-assets.emergentagent.com/job_japamix-anapolys/artifacts/4ynln0qh_PHOTO-2026-01-20-14-01-36.jpg",
  "@id": "https://japamix.com.br",
  "url": "https://japamix.com.br",
  "telephone": "(62) 99179-3559",
  "servesCuisine": "Japanese",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "R. Daise Fanstone, Qd 3 - Lt 57",
    "addressLocality": "Anápolis",
    "addressRegion": "GO",
    "postalCode": "75083-450",
    "addressCountry": "BR"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -16.3281,
    "longitude": -48.9534
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "18:00",
      "closes": "23:00"
    }
  ],
  "sameAs": [
    "https://www.instagram.com/japamiix/"
  ],
  "menu": "https://ncommerce-customer.vercel.app/menu/japa-mix",
  "acceptsReservations": "True"
};
